var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 13.4167C8.16032 13.4167 9.27311 12.9557 10.0936 12.1353C10.9141 11.3148 11.375 10.202 11.375 9.04167C11.375 8.5365 11.2408 8.05175 11.0833 7.60083C10.1109 8.56158 9.37241 9.04167 8.86666 9.04167C11.1971 4.95833 9.91666 3.20833 6.41666 0.875C6.70833 3.79167 4.78566 5.11817 4.00283 5.85492C3.36427 6.45556 2.92088 7.23419 2.73016 8.08986C2.53944 8.94552 2.61017 9.83875 2.9332 10.6537C3.25622 11.4687 3.81663 12.1678 4.54177 12.6605C5.26691 13.1531 6.12333 13.4166 6.99999 13.4167ZM7.41416 3.05375C9.30474 4.65792 9.31408 5.9045 7.85341 8.46358C7.40949 9.24117 7.97124 10.2083 8.86666 10.2083C9.26799 10.2083 9.67399 10.0917 10.1027 9.86125C9.97566 10.3413 9.73886 10.7853 9.411 11.1583C9.08314 11.5313 8.67317 11.8231 8.21337 12.0108C7.75357 12.1984 7.25648 12.2767 6.76127 12.2396C6.26605 12.2024 5.78622 12.0508 5.35955 11.7967C4.93288 11.5426 4.57102 11.1929 4.30248 10.7752C4.03393 10.3574 3.86602 9.88305 3.81197 9.38939C3.75792 8.89573 3.81921 8.39626 3.99101 7.93032C4.1628 7.46437 4.44042 7.04467 4.80199 6.70425C4.87549 6.63542 5.24824 6.30467 5.26458 6.29008C5.51191 6.06842 5.71549 5.87183 5.91674 5.65658C6.63424 4.88775 7.14991 4.03492 7.41358 3.05375H7.41416Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2.62537,
    y1: 0.875,
    x2: 11.4114,
    y2: 0.998305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED456C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4A362"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireLine);
export default __webpack_public_path__ + "static/media/fire-line.a786af2d.svg";
export { ForwardRef as ReactComponent };